import React from 'react';
import { Skeleton } from 'antd';
import './skeletons.css';

/**
 * ButtonSkeleton Component
 *
 * Displays a skeleton loading state for buttons.
 * Used to replace spinners in loading buttons for consistent loading experience.
 *
 * @param {string|number} width - Button width (default: 'auto')
 * @param {string|number} height - Button height (default: '36px')
 * @param {string} shape - Button shape: 'default', 'circle', 'round' (default: 'default')
 */
const ButtonSkeleton = ({
  width = 'auto',
  height = '36px',
  shape = 'default'
}) => {
  return (
    <div className="button-skeleton" style={{ width, height }}>
      <Skeleton.Button
        active
        size="small"
        shape={shape}
        style={{
          width: '100%',
          height: '100%'
        }}
      />
    </div>
  );
};

export default ButtonSkeleton;
